import React, { Component } from 'react';
import NavButton from '../component/NavButton.js';

export default class ASMAdminNav extends Component{
	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = {current:'Gift_Orders'};
	}

	handleClick(navTo){ //method that passes up the page selected based on the nav button that has been clicked
		this.props.navClick(this.state.current,navTo);
		this.setState({current:navTo});
	}

	componentDidUpdate(prevProps,prevState){
		if(prevProps.leaveShop !== this.props.leaveShop && this.props.leaveShop && this.state.current !== 'Gift_Orders'){
			this.setState({current:'Gift_Orders'});
		}
	}

	render(){
		const divStyle = "fl w-20 bl pl1 pr1 b--white asmNavDiv";
		const buttonstyle = "dim b w-100 pt2 pb2 bn white bg-navy ml1 mr1 pointer";
		return(
			<div>
				<div className="fl w-20">
					<NavButton name="Gift Orders" onClick={this.handleClick} styles={buttonstyle}/>
				</div>
				<div className={divStyle}>
					<NavButton name="Order History" onClick={this.handleClick} styles={buttonstyle}/>
				</div>
				<div className={divStyle}>
					<NavButton name="Admin Center" onClick={this.handleClick} styles={buttonstyle}/>
				</div>
				<div className={divStyle}>
					<NavButton name="Shop" onClick={this.handleClick} styles={buttonstyle}/>
				</div>
				<div className={divStyle}>
					<button onClick={this.props.logout} className={buttonstyle}>Logout</button>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ASMAdminNav.js